import { createContext, useContext, useState } from "react";

export type ThemeName = "light" | "dark";

type ThemeContextType = {
    theme: Theme;
    setTheme: (theme: Theme) => void;
};

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export default function ThemeContextProvider({
    children,
    defaultTheme,
}: {
    children: React.ReactNode;
    defaultTheme: Theme;
}) {
    const [currentTheme, setCurrentTheme] = useState<Theme>(defaultTheme);
    const setTheme = (theme: Theme) => {
        setCurrentTheme(theme);
    };

    return (
        <ThemeContext.Provider value={{ theme: currentTheme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error("useThemeContext must be used within a ThemeProvider");
    }
    return context;
};
